export default "__VITE_ASSET__AMvk11n___"